module.exports = __webpack_public_path__ + "static/pergi-rame-rame-31882437a2acfa5d71c30516a2eb891b.png";